module.exports = __webpack_public_path__ + "static/media/bill_grey.a6e9c7bc.svg";